import { Component } from "react";
import classNames from "classnames";
import { withRouting } from "@/components/shared/withRouting";
import Loader from "../shared/Loader";
import isEmpty from "lodash/isEmpty";
import Modal from "react-modal";
import ModalHeader from "../modals/ModalHeader";
import ModalBody from "../modals/ModalBody";

import Alert from "../shared/Alert";
import { Button } from "../shared/Button";
import ExternalLink from "../shared/ExternalLink";
import TextInput from "../shared/TextInput";

class RequireTwoFactor extends Component {
  constructor() {
    super();

    this.state = {
      password: "",
      twoFACode: "",
      showSecret: false,
      showRecoveryCodes: true
    };
  }

  handleFormChange = (field, value) => {
    if (this.props.twoFactorServerErr) {
      this.props.clearServerError();
    }
    let nextState = {};
    nextState[field] = value;
    this.setState(nextState);
  };

  showSecret = () => {
    this.setState({
      showSecret: true
    });
  };

  confirmCode = async () => {
    const payload = {
      code: this.state.twoFACode.trim()
    };
    await this.props.finalizeCode(payload).then(() => {
      this.setState({ displayRecoveryCodeModal: true });
    });
  };

  closeRecoveryCodeModal = () => {
    this.setState({ displayRecoveryCodeModal: true });
    this.props.clearRecoveryCodes();
    this.props.navigate("/login");
  };

  onTurnOnClick = () => {
    this.props.confirmPassword({}, true);
  };

  handleCancel = () => {
    this.props.setTwoFactorStep("main");
  };

  buildRecoveryCodes = () => {
    return this.props.recoveryCodes.map((code, i) => (
      <p
        key={i}
        className="mb-3 px-1 py-0.5 text-[90%] font-mono bg-page-bg rounded-sm text-xs leading-[1.7]"
      >
        {code}
      </p>
    ));
  };

  componentDidUpdate(lastProps) {
    if (this.props.twoFactorStep !== lastProps.twoFactorStep) {
      this.setState({ twoFACode: "" });
      if (this.props.twoFactorStep === "configure") {
        setTimeout(() => {
          this.refCodeInput.focus();
        }, 50);
      }
    }
    if (
      this.props.twoFactorIsEnabled !== lastProps.twoFactorIsEnabled &&
      this.props.twoFactorIsEnabled
    ) {
      this.setState({
        showRecoveryCodes: true
      });
    }
  }

  componentDidMount() {
    if (this.props.twoFactorStep !== "main") {
      this.props.setTwoFactorStep("main");
    }
    this.props.checkTwoFactor();
  }

  render() {
    const { dataLoading } = this.props;

    return (
      <div className="flex flex-1 min-h-0 items-center justify-center bg-page-bg auth-pages h-full overflow-y-auto">
        <div className="flex flex-col flex-none max-md:max-w-[80%]">
          {dataLoading.twoFactorLoading ? (
            <div className="flex flex-1 min-h-0 justify-center items-center">
              <Loader size="80" />
            </div>
          ) : (
            <div className="flex">
              {this.props.twoFactorStep === "main" ? (
                <div className="max-w-[680px] text-center items-center">
                  <span className="icon u-requireTFAIcon mb-10"></span>
                  <p className="font-['Montserrat',sans-serif] font-medium text-hex-326de6 text-[30px] !text-center text-hex-2e96c2 mb-5 text-center">
                    You must enable Two-Factor authentication
                  </p>
                  <div className="flex flex-col">
                    <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base leading-[29px] font-normal text-gray-410 leading-[1.7]">
                      Your organization has required that Two-Factor authentication be
                      enabled for all accounts. In order to log in and use the Vendor
                      Portal you must enable Two-Factor auth.
                    </p>
                    <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base leading-[29px] font-normal text-gray-410 leading-[1.7] mt-3">
                      With two-factor authentication (2fa) enabled, you'll be asked to
                      provide an authentication code as well as your password, when you
                      access the Replicated vendor portal.
                    </p>

                    <div
                      className={classNames("mt-5", {
                        "hidden": this.props.twoFactorIsEnabled
                      })}
                    >
                      <div className="min-h-[100px]">
                        <Button
                          kind="primary-purple"
                          size="large"
                          onClick={this.onTurnOnClick}
                        >
                          Enable Two-Factor authentication
                        </Button>
                      </div>
                      <p className="text-gray-410 text-xs mt-0">
                        <ExternalLink
                          href="https://help.replicated.com/docs/kb/supporting-your-customers/set-up-2fa/"
                          className="text-hex-2e96c2 font-medium"
                        >
                          Learn more
                        </ExternalLink>{" "}
                        about Two-Factor authentication.
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="max-w-[680px] text-center">
                  <span className="icon u-requireTFAIcon mb-10"></span>
                  <p className="font-['Montserrat',sans-serif] font-bold text-indigo-500 text-[30px] !text-left max-lg:mt-[70px] text-hex-2e96c2 mb-5">
                    You must enable Two-Factor authentication
                  </p>
                  <div className="flex flex-col flex-1 min-h-0">
                    <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base leading-[29px] font-normal text-gray-410 leading-[1.4] mt-5">
                      Before continuing, you will need to install a supported two-factor
                      authentication app on your device. Visit our{" "}
                      <ExternalLink
                        href="https://help.replicated.com/docs/kb/supporting-your-customers/set-up-2fa/"
                        className="text-hex-2e96c2 font-medium"
                      >
                        Help Center
                      </ExternalLink>{" "}
                      to get additional help.
                    </p>
                    <div className="flex flex-none mt-10">
                      <div className="flex flex-col flex-none mr-3 relative top-[-6px]">
                        <img
                          src={this.props.qrCodeUrl}
                          alt="Two-factor authentication QR code"
                          style={{ width: "200px" }}
                        />
                      </div>
                      <div className="flex-1 min-h-0 text-left">
                        <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base leading-[29px] font-normal leading-[1.4] text-gray-500">
                          1. Scan the QR Code with your app
                        </p>
                        <p className="text-xs font-normal text-gray-410 leading-[1.4] mt-1.5">
                          {!this.state.showSecret ? (
                            <span>
                              Can't use the QR code?{" "}
                              <span
                                className="text-hex-2e96c2 font-medium hover:underline hover:cursor-pointer"
                                onClick={this.showSecret}
                              >
                                Use this text code
                              </span>{" "}
                              instead
                            </span>
                          ) : (
                            <span>
                              Enter this code in your app:{" "}
                              <span className="font-medium text-base text-hex-65a61d">
                                {this.props.secret}
                              </span>
                            </span>
                          )}
                        </p>
                        <div className="mt-3">
                          <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base leading-[29px] font-normal leading-[1.4] text-gray-500">
                            2. Enter the code your app generated
                          </p>
                          {this.props.twoFactorServerErr &&
                          this.props.twoFactorStep === "configure" ? (
                            <Alert variant="error" className="mt-3 mb-1.5">
                              {this.props.twoFactorServerErrMessage}
                            </Alert>
                          ) : null}
                          <TextInput
                            name="twoFACode"
                            className="mt-5"
                            placeholder="123456"
                            ref={input => (this.refCodeInput = input)}
                            value={this.state.twoFACode}
                            onChangeValue={value =>
                              this.handleFormChange("twoFACode", value)
                            }
                          />
                          <div className="flex">
                            <Button
                              kind="secondary-purple"
                              className="mt-3 mr-1.5"
                              onClick={() => {
                                this.handleCancel();
                              }}
                              disabled={dataLoading.authCodeLoading}
                            >
                              Cancel
                            </Button>
                            <Button
                              kind="primary-purple"
                              className="mt-3"
                              onClick={this.confirmCode}
                              disabled={
                                dataLoading.authCodeLoading ||
                                this.state.twoFACode === ""
                              }
                            >
                              {dataLoading.authCodeLoading
                                ? "Authenticating"
                                : "Continue"}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {this.state.displayRecoveryCodeModal && (
          <Modal
            isOpen={this.state.displayRecoveryCodeModal}
            ariaHideApp={false}
            contentLabel="Recovery Codes Modal"
            className="auth-pages Modal DefaultSize"
            onRequestClose={this.closeRecoveryCodeModal}
          >
            <ModalHeader
              title="Your recovery codes"
              requestClose={this.closeRecoveryCodeModal}
            />
            <ModalBody>
              {!isEmpty(this.props.recoveryCodes) ? (
                <div>
                  <p className="text-sm mb-1.5 text-center text-gray-410 leading-[1.4]">
                    If you lose access to your supported 2FA app, use your recovery
                    codes to log in to your account.
                  </p>
                  <div className="">
                    <div className="flex mt-3">
                      <span className="icon u-warningIcon self-center pr-3"></span>
                      <p className="text-xs text-gray-410 leading-[1.7] pl-1.5">
                        Keep these codes in a secure location. Codes can only be used
                        once, and these codes will not be shown later.
                      </p>
                    </div>
                    <div className="mt-5 text-center">
                      {this.buildRecoveryCodes()}
                    </div>
                    <p className="text-sm mt-3 text-center leading-[1.7] text-gray-410">
                      Codes cannot be displayed again after leaving the page. Store them
                      well.
                    </p>
                  </div>
                  <div className="text-center mt-3">
                    <Button kind="primary-purple" onClick={this.closeRecoveryCodeModal}>
                      Ok got it!
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="flex flex-1 min-h-0 justify-center items-center">
                  <Loader size="80" />
                </div>
              )}
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default withRouting(RequireTwoFactor);
